import React from 'react'
import Image from '../../components/Image/Image';
import { Card, Elevation } from "@blueprintjs/core";

const PrypoolProductDescription=({product, selected_products, selectProduct})=>{
    const is_selected = selected_products && selected_products.hasOwnProperty(product.id);
    const price = product.prices.filter(price=>{return price.unit_amount>0})[0]
    
    return (
        <Card 
            interactive={true}
            elevation={Elevation.ONE}    
            className={`product-card cover-image ${is_selected?'selected':''}`} 
            onClick={_=>selectProduct(product)} >        
            
            <div className='product-image'>
                <Image src={product.images[0]} />
            </div>
            <h1 className="product-name">{product.name}</h1>
            <div className="product-description">{product.description}</div> 
            <div className="card-footer">
                <div className="product-price">
                    <strong>{price.unit_amount/100} {price.currency}</strong>
                </div>
            </div>                               
        </Card>
    )
}

export default PrypoolProductDescription 